import { Link } from 'react-router-dom';
import Logo from './Logo';
import { DOWNLOAD_URL, SUPPORT_EMAIL } from '../utils/constants';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="section-container footer-inner">
        <div className="footer-brand">
          <span className="nav-logo" aria-hidden="true">
            <Logo size={24} />
          </span>
          <span className="nav-brand-text">
            SolidlyAI <span className="nav-brand-accent">Agents</span>
          </span>
          <p className="footer-tagline">
            A team of AI coworkers you own outright — organized, permissioned, and built on your
            own Claude.
          </p>
        </div>

        <nav className="footer-links" aria-label="Footer">
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#pricing">Pricing</a>
          <a href="#faq">FAQ</a>
          <a href={DOWNLOAD_URL}>Download</a>
          <a href={`mailto:${SUPPORT_EMAIL}`}>Support</a>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </div>

      <div className="footer-bottom">
        <span className="mono">© {year} SolidlyAI Agents</span>
        <span className="mono footer-built">
          Built on Claude · Runs on your machine · {SUPPORT_EMAIL}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
